import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c26c54b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column","height":"100vh"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"50px","margin-bottom":"20px"} }, "Klleon X GiantStep", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      style: {"max-width":"500px"},
      model: _ctx.formState
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, _mergeProps(_ctx.layout, {
          label: "아이디",
          name: "username",
          rules: [{ required: true, message: '아이디를 입력해주세요.' }]
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.username,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.username) = $event)),
              type: "email"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_UserOutlined, { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 16, ["rules"]),
        _createVNode(_component_a_form_item, _mergeProps(_ctx.layout, {
          label: "비밀번호",
          name: "password",
          rules: [{ required: true, message: '비밀번호를 입력해주세요.' }]
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.formState.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event))
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_LockOutlined, { class: "site-form-item-icon" })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 16, ["rules"]),
        _createVNode(_Transition, { name: "bounce" }, {
          default: _withCtx(() => [
            (_ctx.isSignUp)
              ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({ key: 0 }, _ctx.layout, {
                  label: "비밀번호 확인",
                  name: "password2",
                  rules: [{ required: true, message: '비밀번호를 입력해주세요.' }]
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: _ctx.formState.password2,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.password2) = $event))
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_component_LockOutlined, { class: "site-form-item-icon" })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 16, ["rules"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              style: {"width":"100%"},
              onClick: _withModifiers(_ctx.submit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isSignUp ? '회원가입' : '로그인'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}